import { attr } from '@ember-data/model';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
export default ItemsV3Base.extend({
  name: attr('string'),
  ordinal: attr('number')
}).reopenClass({
  catalogType() {
    return 'VOID_REASON';
  },
  sortKey: 'name',
  currentUserAffectsEnabledUnitsAll: false
});